import { connect } from 'react-redux';
import CreditSeeMore, {
	DispatchPropsType,
	MapStateType,
} from '../organisms/Credit/SeeMore';
import { Instances } from '../../../constants';
import { FilterType } from '../../../interface';
import {
	changeFilters,
	makeSelectFilters,
	makeSelectInProgress,
	makeSelectObject,
	requestObject,
} from '../../../store/Object';
import {
	changeFilters as objectsChangeFilters,
	changeSearchStr,
} from '../../../store/Objects';
import { IStateType } from '../../../store/models/root.interface';
import withImmutablePropsToJS from 'with-immutable-props-to-js';
import { setCreditFilter } from '../../../store/actions/dashboard.action';

const mapStateToProps = (state: IStateType) => ({
	data: makeSelectObject(Instances.credit)(state) || [],
	tabularData: makeSelectObject(Instances.creditTabular)(state) || [],
	filters: makeSelectFilters(Instances.credit)(state),
	inProgress: makeSelectInProgress(Instances.creditTabular)(state),
	smsOverviewData: makeSelectObject(Instances.smsOverview)(state),
	selectedFilter: state.dashboard.creditFilterKey
});

const mapDispatchToProps = (dispatch: any) => ({
	onLoad: (filter: FilterType) => {
		dispatch(requestObject(Instances.creditTabular, undefined, filter));
	},
	onFilterChange: (filter: FilterType) => {
		dispatch(changeFilters(Instances.credit, filter));
		dispatch(changeFilters(Instances.creditTabular, filter));
		dispatch(objectsChangeFilters(Instances.creditDetailed, filter));
	},
	onSearchStrChange: (searchStr?: string) =>
		dispatch(changeSearchStr(Instances.creditDetailed, searchStr || '')),
	setFilterKey: (filterKey: string) => dispatch(setCreditFilter(filterKey))
});

export default connect<MapStateType, DispatchPropsType, unknown, IStateType>(
	mapStateToProps,
	mapDispatchToProps
)(withImmutablePropsToJS(CreditSeeMore));
